import styled from 'styled-components';

const Container = styled.div`
  margin-top: 81px;
  padding: 0 28px;

  .hero-inline-progressive-form {
    justify-content: center;
  }

  .hero-inline-progressive-form--legal-info {
    opacity: 1;
    width: 500px;
    margin: 0 auto;

    p {
      text-align: center;
      color: ${({ theme }) => (theme === 'light' ? '#FFF' : '#000')};
    }
  }

  button {
    font-size: 23px;
    font-weight: normal;
  }

  .ant-row.ant-form-item:first-child {
    width: 314px;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding: 0;

    .ant-row.ant-form-item:first-child,
    .hero-inline-progressive-form--legal-info {
      width: 100%;
    }
  }
`;

export { Container };
